import React from "react";
import classNames from "classnames";

export const Button = ({
  children,
  onClick,
  className = "",
  type = "button",
  variant = "primary", // default
  disabled = false,
  ...props
}) => {
  const baseClasses =
    "px-4 py-2 rounded font-medium transition duration-200 focus:outline-none";

  const variantClasses = {
    primary: "bg-blue-600 text-white hover:bg-blue-700",
    secondary: "bg-gray-600 text-white hover:bg-gray-700",
    outline: "bg-white border border-gray-300 text-gray-800 hover:bg-gray-100",
    danger: "bg-red-600 text-white hover:bg-red-700",
  };

  const disabledClasses = "opacity-50 cursor-not-allowed";

  return (
    <button
      type={type}
      onClick={onClick}
      className={classNames(
        baseClasses,
        variantClasses[variant],
        disabled && disabledClasses,
        className
      )}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};
